import React from 'react';

class ChartLoadingSpinner extends React.Component {
  render() {
    return (
      <div style={{ width: '100%', height: '100%', textAlign: 'center' }}>
        <img
          src={require('assets/images/loading-simple.gif')}
          width="100px"
          height="100px"
        />
      </div>
    );
  }
}

export default ChartLoadingSpinner;
